import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSCTATagName: string = 'hhds-cta';
const TAG_NAME: string = HHDSCTATagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export class HHDSCTA extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = /* html */ `
      <div class="${TAG_NAME} container">
				<div class="grid">
					<div class="${TAG_NAME}__content col-span-4 md:col-span-8 md:col-start-3 lg:col-span-8 lg:col-start-9">
						<h2 class="${TAG_NAME}__header heading heading--02 animate"><slot name="header"></slot></h2>
					</div>
					<div class="${TAG_NAME}__content col-span-4 md:col-span-8 md:col-start-3 lg:col-span-10 lg:col-start-8">
						<p class="${TAG_NAME}__body paragraph animate"><slot name="body"></slot></p>
						<slot name="cta"></slot>
					</div>
				</div>
			</div>
    `;

		this.setInnerHtml('', '', html);
		this.observeSlotChanges(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
